var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCh = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M356.174 222.609h-66.783v-66.783h-66.782v66.783h-66.783v66.782h66.783v66.783h66.782v-66.783h66.783z"
})));

export default SvgCh;